import {Component, ElementRef, inject, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ChatBotStateService} from './ChatBotStateService';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-chatbot-widget',
  imports: [FormsModule, TranslocoPipe],
  templateUrl: './chatbot-widget.component.html',
  styleUrl: './chatbot-widget.component.scss',
})
export class ChatbotWidgetComponent {
  readonly messagesContainer = viewChild<ElementRef<HTMLDivElement>>('messagesContainer');

  readonly chat: ChatBotStateService = inject(ChatBotStateService);

  toggle(): void {
    const shouldOpen = !this.chat.isOpen();
    this.chat.setOpen(shouldOpen);

    if (shouldOpen) {
      this.scrollToBottomDeferred();
    }
  }

  async onSend(): Promise<void> {
    await this.chat.sendMessage();
    this.scrollToBottomDeferred();
  }

  private scrollToBottomDeferred(): void {
    setTimeout(() => this.scrollToBottom(), 0);
  }

  private scrollToBottom(): void {
    const container = this.messagesContainer()?.nativeElement;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }
}
